import Vue from "vue";

import {
  Button,
  Breadcrumb,
  BreadcrumbItem,
  Carousel,
  CarouselItem,
  Cascader,
  Checkbox,
  CheckboxGroup,
  Dialog,
  Input,
  Empty,
  Menu,
  MenuItem,
  Submenu,
  MenuItemGroup,
  Popover,
  Radio,
  RadioGroup,
  Scrollbar,
  Select,
  Table,
  Tabs,
  TabPane,
  Timeline,
  TimelineItem,
  Loading,
  Message
} from "iways-ui";

Vue.use(Button);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Cascader);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Dialog);
Vue.use(Empty);
Vue.use(Input);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Popover);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Scrollbar);
Vue.use(Select);
Vue.use(Table);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Timeline);
Vue.use(TimelineItem);
Vue.use(Loading.directive);

Vue.prototype.$message = Message;
Vue.prototype.$loading = Loading.service;
